if (!customElements.get('rb-filters')) {
  class RechargeFilters extends HTMLElement {
    connectedCallback() {
      this.amount = 0;
      this.actives = null;
      this._innerListenersAttached = false;

      this.recharge = {
        filters: null,
        button: null,
      }

      document.addEventListener("bundling-widget:ready", this.onRechargeReady.bind(this));
      document.addEventListener("Recharge::bundling-widget::reload", this.onWidgetReload.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener("bundling-widget:ready", this.onRechargeReady.bind(this));
      document.removeEventListener("Recharge::bundling-widget::reload", this.onWidgetReload.bind(this));

      if (this.button) this.button.removeEventListener('click', this.openFilter.bind(this));
      if (this.filters) this.filters.forEach(filter => filter.removeEventListener('click', this.activateFilter.bind(this)));
    }

    onWidgetReload() {
      // bundling-widget:ready will fire again after the reload, but Vue takes time to
      // re-render the filter list — use a longer delay here as a reliable second pass
      setTimeout(() => {
        if (this.recharge.filters) {
          this.recharge.filters.forEach(filter => filter.removeEventListener('change', this.onChange.bind(this)));
        }
        this.recharge.filters = Array.from(document.querySelectorAll('.rb-filter-item input[type="checkbox"]'));
        this.recharge.filters.forEach(filter => filter.addEventListener('change', this.onChange.bind(this)));

        this.getFilterByUrl();
      }, 400);
    }

    onRechargeReady() {
      if (!this._innerListenersAttached) {
        this.button = this.querySelector('[data-open]');
        this.button.addEventListener('click', this.openFilter.bind(this));

        this.filters = this.querySelectorAll('[data-filter]');
        this.filters.forEach(filter => filter.addEventListener('click', this.activateFilter.bind(this)));

        this._innerListenersAttached = true;
      }

      setTimeout(() => {
        const configurator = document.querySelector('.rb-configuration');
        configurator.removeAttribute('hidden');

        this.recharge.button = document.querySelector('.rb-filters-nav .rb-link');

        if (this.recharge.filters) {
          this.recharge.filters.forEach(filter => filter.removeEventListener('change', this.onChange.bind(this)));
        }
        this.recharge.filters = Array.from(document.querySelectorAll('.rb-filter-item input[type="checkbox"]'));
        this.recharge.filters.forEach(filter => filter.addEventListener('change', this.onChange.bind(this)));

        //Trigger URL Filters
        this.getFilterByUrl();
      }, 100)
    }

    updateAmount() {
      //Amount of active filters
      const label = this.querySelector('[data-value]')
      const actives = document.querySelectorAll('.rb-filters .rb-filter-item input[type="checkbox"][aria-checked="true"]');

      if(!label || !actives) {
        return console.error('RechargeFilters', 'no label no actives');
      }

      this.actives = actives;

      this.amount = actives.length;
      label.innerText = this.amount > 0 ? `(${this.amount})` : '';
    }

    openFilter(e) {
      e.preventDefault();
      
      if(!this.recharge.button) {
        return console.error('RechargeFilters', 'no button')
      }

      this.recharge.button.click();
    }

    activateFilter(event) {
      const button = event.target;
      if(!button || !button.dataset.filter) {
        return console.error('RechargeFilters', 'cant find target', filter, target)
      }
      
      const { filter } = button.dataset;

      const target = document.querySelector(`.rb-filter-list input[id="${filter}"]`);
      if(!target) {
        return console.error('RechargeFilters', 'cant find target', filter, target)
      }

      const filters = this.querySelectorAll('[data-filter].active')
      filters.forEach(filter => {
        if(filter !== button) {
          filter.click();
        }
      });

      button.classList.toggle('active');
      target.click();
    }

    syncFilterButtons() {
      const buttons = this.querySelectorAll('[data-filter]');
      buttons.forEach(button => {
        const { filter } = button.dataset;
        const input = document.querySelector(`.rb-filter-list input[id="${filter}"]`);
        if (input) {
          button.classList.toggle('active', input.checked);
        }
      });
    }

    onChange(event) {
      setTimeout(() => {
        this.updateAmount();
        this.syncFilterButtons();
      }, 100);

      //Dispatch
      this.dispatchEvent();

      const params = new URLSearchParams(window.location.search);
      params.delete('filter');

      const activeFilters = this.recharge.filters.filter(input => input.checked).map(input => input.id);
      activeFilters.forEach(filter => params.append('filter', filter));

      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState(null, '', newUrl);
    }

    getFilterByUrl() {
      const params = new URLSearchParams(window.location.search);
      const filters = params.getAll('filter');

      filters.forEach((filter) => {
        const input = document.querySelector(`li[data-rb-filter*="${filter}"] input[type="checkbox"][aria-checked="false"]`);
        if(input && typeof input !== 'undefined') {
          input.click();
          input.setAttribute("aria-checked", true);
        }

        const quick = document.querySelector(`rb-filters [data-filter="${filter}"]`)
        if(quick) {
          quick.classList.add('active');
        }
      });
    }

    dispatchEvent() {
      //Get all active Filters
      const actives = this.recharge.filters.filter(input => input.checked).map(input => input.id)
      const inactives = this.recharge.filters.filter(input => !input.checked).map(input => input.id)

      document.dispatchEvent(new CustomEvent('recharge:filter', {
        active: actives,
        inactive: inactives
      }))
    }
  }
  customElements.define('rb-filters', RechargeFilters);
}